export default __webpack_public_path__ + "static/media/hr.00a76e1b.svg";